import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { X } from 'lucide-react';
import { adminRouteList } from '../../Config/routeConfig';

interface AdminSidebarProps {
  sidebarOpen: boolean;
  setSidebarOpen: (open: boolean) => void;
}

const AdminSidebar: React.FC<AdminSidebarProps> = ({ sidebarOpen, setSidebarOpen }) => {
  const location = useLocation();
  const adminNavigationItems = adminRouteList.filter((a) => a.showMenuBar);

  return (
    <aside
      className={`fixed top-0 left-0 h-full w-64 bg-[#020303] text-white shadow-md transform transition-transform duration-300 ease-in-out z-50 lg:static lg:translate-x-0 ${sidebarOpen ? 'translate-x-0' : '-translate-x-full'
        }`}
    >
      <div className="h-16 flex items-center justify-between px-6 border-r border-b border-gray-600">
        <span className="font-semibold text-xl text-white">Vaultex</span>
        <button className="lg:hidden text-white" onClick={() => setSidebarOpen(false)}>
          <X size={20} />
        </button>
      </div>

      <nav className="flex flex-col p-4 space-y-2">
        {adminNavigationItems.map(({ path, menuLabel, icon }) => {
          const fullPath = `/admin/${path}`;
          const isActive = location.pathname.startsWith(fullPath);
          return (
            <Link
              key={path}
              to={fullPath}
              className={`flex items-center gap-3 px-4 py-2 rounded-md transition-colors ${isActive
                ? 'bg-[#009FE3] text-white'
                : 'hover:bg-[#009FE3] hover:text-white'
                }`}
            >
              {icon}
              <span>{menuLabel}</span>
            </Link>
          );
        })}
      </nav>
    </aside>
  );
};

export default AdminSidebar;
